import axios from "axios";
import { axiosInstance } from "../";
import { API_BASE_URL, APP_VERSION } from "config_environment";
import { LocalStorageKey } from "utils";

// Use production.ugenie.io for communities/joined only if current API is api.ugenie.io
const PRODUCTION_API_URL = "https://production.ugenie.io/api/v1";
const shouldUseProduction = API_BASE_URL.includes("api.ugenie.io");

const productionAxios = axios.create({
	baseURL: shouldUseProduction ? PRODUCTION_API_URL : API_BASE_URL,
	headers: {
		"Content-Type": "application/json",
		"X-UHUBS-PLATFORM": "web",
		"X-UHUBS-PLATFORM-VERSION": APP_VERSION,
	},
});

// Add auth token interceptor
productionAxios.interceptors.request.use((config) => {
	const token = localStorage.getItem(LocalStorageKey);
	if (token && config.headers) {
		config.headers["Authorization"] = token;
	}
	return config;
});

const getInstance = () =>
	shouldUseProduction ? productionAxios : axiosInstance();

export const communitiesJoined = {
	get: (payload?: { q?: string; page?: number; slug?: string }) =>
		getInstance().get("/communities/joined", { params: payload }),
};
